@if (loading()) {
  <aux-table-skeleton />
} @else {
  <div class="my-4 flex flex-row-reverse">
    <aux-button
      variant="secondary"
      label="Export"
      icon="FileExport"
      data-pendo-id="invoice-items-export-button"
      [disabled]="gridData().length === 0"
      (click)="onExport()"
    />

    <aux-button
      variant="secondary"
      label="Map to Budget"
      class="mr-2"
      data-pendo-id="map-to-budget-integration-items-button"
      [template]="mapToBudgetTooltip().length > 1 ? errorArrayTooltip : undefined"
      [auxTooltip]="mapToBudgetTooltip().length === 1 ? mapToBudgetTooltip()[0] : ''"
      [disabled]="!!mapToBudgetTooltip().length"
      (clickEmit)="openMapActivitiesModal()"
    ></aux-button>

    <ng-template #errorArrayTooltip>
      <aux-errors-tooltip [errors]="mapToBudgetTooltip()" />
    </ng-template>
  </div>

  <ag-grid-angular
    class="ag-theme-aux tabular-nums"
    [rowData]="gridData()"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [suppressDragLeaveHidesColumns]="false"
    [domLayout]="'autoHeight'"
    (gridReady)="gridAPI.set($event.api)"
    auxStickyGrid
  />
}
